module.exports = __webpack_public_path__ + "img/image-04.a18b9ae8.jpeg";